import { DataTableCellContent } from './types';

export const getPlainText = <T extends string>(
  cellContent: DataTableCellContent<T>[T]
) => {
  if (cellContent.plainText) {
    return cellContent.plainText;
  }

  return cellContent.Component;
};
